import script from "./ScoreTemplateManage.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreTemplateManage.vue?vue&type=script&setup=true&lang=js"

import "./ScoreTemplateManage.vue?vue&type=style&index=0&id=18025f54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18025f54"]])

export default __exports__